import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Modal, Button } from 'controls'
import { Row, Col } from 'flexbox'

import styles from './styles'

class ModalConfirm extends Component {
  static propTypes = {
    message: PropTypes.string.isRequired,
    children: PropTypes.any.isRequired,
    buttonConfirmLabel: PropTypes.string.isRequired,
    onConfirm: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    loading: PropTypes.bool.isRequired,
    disabledConfirm: PropTypes.bool
  }

  static defaultProps = {
    message: '',
    loading: false,
    showRejectButton: true,
    buttonConfirmLabel: 'Aceptar',
    buttonRejectLabel: 'Cancelar'
  }

  render() {
    const {
      message,
      children,
      buttonConfirmLabel,
      buttonRejectLabel,
      onConfirm,
      onCancel,
      loading,
      disabledConfirm,
      showRejectButton,
      okButtonProps,
      styleButtonsType = "rounded",
      ...modalProps
    } = this.props

    return (
      <Modal {...modalProps} onClose={onCancel}>
        <div className="container">
          <header>{message}</header>
          {children}
          <br />
          <Row>
            {showRejectButton && (
              <Col xs={6} sm={4} smOffset={1}>
                <Button
                  fullWidth
                  outline
                  color="secondary"
                  styleType={styleButtonsType}
                  onClick={onCancel}
                >
                  {buttonRejectLabel}
                </Button>
              </Col>
            )}
            <Col xs={showRejectButton ? 6 : 12} sm={showRejectButton ? 4 : 12} smOffset={showRejectButton ? 2 : 0}>
              <Button
                fullWidth
                outline
                color="success"
                styleType={styleButtonsType}
                onClick={onConfirm}
                loading={loading}
                disabled={disabledConfirm}
                {...okButtonProps}
              >
                {buttonConfirmLabel}
              </Button>
            </Col>
          </Row>
        </div>
        <style jsx>{styles}</style>
      </Modal>
    )
  }
}

export default ModalConfirm
